
import { useSelector } from "react-redux";
import firstLook from '/assets/images/srp/tagicons/firstLook.svg';

// import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import {
  Button,
  Col,
  Form,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";

const PropertyTags = ({cmsKeyInfographic}) => {

  const pdpInitData = useSelector((state) => state.pdp.pdpInitData);

     const {
     
      financialType
     
    } = pdpInitData.listingDetail || {};

    
  // const isHotProperty = pdpInitData?.propertySpecialDetails?.isHotProperty !== null &&  pdpInitData?.propertySpecialDetails?.isHotProperty === 'Y' || 'N';
  const isFirstLook = pdpInitData?.propertyDetails?.firstLook === "Y";
  const isHotProperty = pdpInitData?.propertySpecialDetails?.isHotProperty === 'Y' ? true : false;

  const isFcProxyBidEnabled = pdpInitData?.fcProxyBidEnabled;

 const propCategory =
        pdpInitData?.propertyDetails?.commonAttributes?.propCategory;


  // const isNoBuyerPremium =
  //     financialType.length === 1 &&
  //     (financialType.includes('CASH') ||
  //     financialType.includes('MORTGAGE')) &&
  //     cmsKeyInfographic.pdpStaticContent[propCategory]?.conditionBased?.noBuyersPremium
  //       ?.staticContentHead;

    let isSeller =
    pdpInitData?.propertySpecialDetails?.pdpEnabledFeatures?.indexOf('SELLER') !==
    undefined &&
    pdpInitData?.propertySpecialDetails?.pdpEnabledFeatures?.indexOf('SELLER') !== -1;


  //  const isNoBuyerPremium = pdpInitData?.listingDetail?.isNoBuyerPremium === true ? true : false

   const isNoBuyerPremium = isSeller && pdpInitData?.propertySpecialDetails?.listingType !== 'TRNL';
    
  const signatureSeller = pdpInitData?.propertySpecialDetails?.sellerId;
  //  const selfShowing =  pdpInitData?.propertySpecialDetails?.isHotProperty || 'N';

  const selfShowing =
    pdpInitData?.PropertyDetails?.rentlyEnabledFlag === 'Y' ? true : false;

  // const isCommercialProperty =
  // pdpInitData?.propertySpecialDetails?.commercialRetailTag || 'N';
  // const fcProxyBidEnabled = pdpInitData?.fcProxyBidEnabled || false;
  // const isNewToHubzu =  pdpInitData?.propertySpecialDetails?.isNewToHubzu || 'N';

  let iwf_reserve =
    !pdpInitData?.listingDetail?.clientCodeRestrictedFlag &&
      pdpInitData?.listingDetail?.parentBulkPropertyFlag !== 'Y' &&
      (pdpInitData?.listingDetail.invrAprvlReqdProp === 'Y' || pdpInitData?.listingDetail.invrAprvlReqdProp === 'true') &&
      (pdpInitData?.listingDetail?.reserveMetFlag === 'Y' || pdpInitData?.listingDetail?.reserveMetFlag)
      ? false
      : pdpInitData?.listingDetail?.reserveMetFlag;

  //   const fcOnlineFlagPC =
  //   pdpInitData?.fcOnlineFlag !== undefined ? pdpInitData?.fcOnlineFlag : pdpInitData?.fcOnlineFlag;

  //   let iwf_reservee =
  //     fcOnlineFlagPC === 'Y' || pdpInitData.fcOnlineFlag === 'Y'
  //       ? false
  //       : iwf_reserve;

  // const isCommercialProperty = PropertyItem?.commercialRetailTag === 'Y' ? true : false;
  // const isSelfShowing =
  // pdpInitData?.PropertyDetails?.rentlyEnabledFlag === 'Y' ? true : false;

  //const isReserveMet = PropertyItem?.reserveMet === "Y" ?true : false;
  const isReserveMet = iwf_reserve ? true : false;


  const renderReserveIcon = () => {
    return (

      <><OverlayTrigger
        placement="bottom"
        overlay={(props) => (

          <Tooltip {...props}>

            Reserve Met
          </Tooltip>
        )}
      >
        <img style={{ width: 40, height: 40 }} src="/assets/images/reserveMet.png" alt="Reserve Met" />
      </OverlayTrigger>


      </>



    );
  };



  const renderSelfShowingIcon = () => {
    return (


      <><OverlayTrigger
        placement="bottom"
        overlay={(props) => (

          <Tooltip {...props}>

            Self Showing
          </Tooltip>
        )}
      >
        <img style={{ width: 40, height: 40 }}
          src="/assets/images/selfShowing.png"
          data-tip="Self Showing"

          alt="Self Showing" />
      </OverlayTrigger>
      </>


    );


  };

  const renderFirstLookIcon = () => {
    return (
      <>
        <OverlayTrigger
          placement="bottom"
          overlay={(props) => (
            <Tooltip {...props}>
              First Look Period
            </Tooltip>
          )}
        >
          <img src={firstLook} height={40} width={40} style={{minHeight: 40}} 
            data-tip="First Look Period"
            alt="First Look Period"
          />
        </OverlayTrigger>
      </>
    );
  };

  const renderHotPropertyIcon = () => {
    return (

      <><OverlayTrigger
        placement="bottom"
        overlay={(props) => (

          <Tooltip {...props}>

            Hot Property
          </Tooltip>
        )}
      >
        <img style={{ width: 40, height: 40 }}
          src="/assets/images/hotProperty.png"
          data-tip="Hot Property"
          alt="Hot Property" />
      </OverlayTrigger>
      </>



    );
  };

  const renderProxyBidIcon = () => {
    return (

      <><OverlayTrigger
        placement="bottom"
        overlay={(props) => (

          <Tooltip {...props}>

            Proxy Property
          </Tooltip>
        )}
      >
        <img style={{ width: 40, height: 40 }}
          src="/assets/images/proxybidicon.png"
          data-tip="Proxy Property"
          alt="Proxy Property" />
      </OverlayTrigger>
      </>



    )

  };

  const renderNoBuyerPremiumIcon = () => {
    return (


      <><OverlayTrigger
        placement="bottom"
        overlay={(props) => (

          <Tooltip {...props}>

            No Buyer’s Premium
          </Tooltip>
        )}
      >
        <img style={{ width: 40, height: 40 }}
          data-tip="No Buyer’s Premium"
          src="/assets/images/noPremium.png"
          alt="No Buyer’s Premium" />
      </OverlayTrigger>
      </>


      // <><img style={{ width: 40, height: 40 }}
      //   data-tip="No Buyer’s Premium"
      //   src="/assets/images/noPremium.png"
      //   alt="No Buyer’s Premium" /><Tooltip /></>

    );


  };

  const renderSignatureSellerIcon = () => {

    return (

      <><OverlayTrigger
        placement="bottom"
        overlay={(props) => (

          <Tooltip {...props}>

            Hubzu Signature Homes
          </Tooltip>
        )}
      >
        <img style={{ width: 40, height: 40 }}
          data-tip="Hubzu Signature Homes"
          src="/assets/images/signatureSeller.png"
          alt="Hubzu Signature Homes" />
      </OverlayTrigger>
      </>



    );
  }

  return (
    <div style={{ position: "absolute", paddingTop: 10, paddingLeft: 10, zIndex:1 }}>
      {(isFirstLook) && renderFirstLookIcon()}
      {isFcProxyBidEnabled && renderProxyBidIcon()}
      {(isHotProperty) && renderHotPropertyIcon()}
      {/* {(tags.commercialProperty || isCommercialProperty) && renderCommercialPropertyIcon()} */}
      {isNoBuyerPremium &&
        renderNoBuyerPremiumIcon()}
      {(isReserveMet) && renderReserveIcon()}

      {selfShowing && renderSelfShowingIcon()}
      {pdpInitData?.propertyDetails?.sellerId === '501' && renderSignatureSellerIcon()}
      <Tooltip />
    </div>
  )




};

export default PropertyTags;